import { mxgraphInstance } from './mxgraphFactory';

/**
 * Layout
 */
export const mxCircleLayout = mxgraphInstance.mxCircleLayout;
export const mxCompactTreeLayout = mxgraphInstance.mxCompactTreeLayout;
export const mxCompositeLayout = mxgraphInstance.mxCompositeLayout;
export const mxEdgeLabelLayout = mxgraphInstance.mxEdgeLabelLayout;
export const mxFastOrganicLayout = mxgraphInstance.mxFastOrganicLayout;
export const mxGraphLayout = mxgraphInstance.mxGraphLayout;
export const mxParallelEdgeLayout = mxgraphInstance.mxParallelEdgeLayout;
export const mxPartitionLayout = mxgraphInstance.mxPartitionLayout;
export const mxRadialTreeLayout = mxgraphInstance.mxRadialTreeLayout;
export const mxStackLayout = mxgraphInstance.mxStackLayout;

/**
* Layout Hierarchical
*/
export const mxHierarchicalLayout = mxgraphInstance.mxHierarchicalLayout;
export const mxSwimlaneLayout = mxgraphInstance.mxSwimlaneLayout;

/**
* Layout Hierarchical Model
*/
export const mxGraphAbstractHierarchyCell = mxgraphInstance.mxGraphAbstractHierarchyCell;
export const mxGraphHierarchyEdge = mxgraphInstance.mxGraphHierarchyEdge;
export const mxGraphHierarchyModel = mxgraphInstance.mxGraphHierarchyModel;
export const mxGraphHierarchyNode = mxgraphInstance.mxGraphHierarchyNode;
export const mxSwimlaneModel = mxgraphInstance.mxSwimlaneModel;

/**
* Layout Hierarchical Stage
*/
export const mxCoordinateAssignment = mxgraphInstance.mxCoordinateAssignment;
export const mxHierarchicalLayoutStage = mxgraphInstance.mxHierarchicalLayoutStage;
export const mxMedianHybridCrossingReduction = mxgraphInstance.mxMedianHybridCrossingReduction;
export const mxMinimumCycleRemover = mxgraphInstance.mxMinimumCycleRemover;
export const mxSwimlaneOrdering = mxgraphInstance.mxSwimlaneOrdering;